module.exports = __webpack_public_path__ + "img/no-results-ratio.b738932f.gif";